import React from 'react';
import { Dialog, DialogContent, Typography, Chip } from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import AppBarModal from '../../../general/AppBarModal';
import DialogAccionesCerrarBienestar from './detalle/DialogAccionesCerrarBienestar';
import { DetalleSolicitud } from '../Bienestar';
import { BIENESTAR_MODAL_PAPER_FLEX } from '../helpers/bienestarDetalleConstants';
import { ETIQUETA_ASISTENCIA, origenEstaIntegrado } from '../services/consultaEstudianteMock';

const SIN_DATO = 'No registra';
const ESTILO_BLOQUE = { marginTop: 14, paddingTop: 14, borderTop: '1px solid #eaeaea' };
const ESTILO_TITULO_BLOQUE = { fontSize: 11.5, color: '#0a3a6b', letterSpacing: '0.04em', marginBottom: 10 };
const ESTILO_ETIQUETA = { fontSize: 12, color: '#5f5f5f', marginBottom: 3 };
const ESTILO_PARRAFO = { fontSize: 12.5, lineHeight: 1.6, marginBottom: 12 };
const ESTILO_RESERVADO = { fontSize: 12.5, color: '#9a9a9a', fontStyle: 'italic' };

const COLORES_ASISTENCIA = {
    asistio: { backgroundColor: '#ddf0dd', color: '#255914' },
    no_asistio: { backgroundColor: '#fadcdc', color: '#8c1c1c' },
    pendiente: { backgroundColor: '#ececec', color: '#5f5f5f' },
};

export function ChipAsistencia({ asistencia }) {
    // Sin cita no hay asistencia que registrar: una solicitud rechazada nunca falto.
    if (!asistencia) return <span style={{ color: '#c4c4c4' }}>—</span>;
    return (
        <Chip
            size="small"
            label={ETIQUETA_ASISTENCIA[asistencia] || asistencia}
            style={{ height: 22, fontSize: 11, borderRadius: 11, ...COLORES_ASISTENCIA[asistencia] }}
        />
    );
}

// Motivo y cierre son el resumen general que pidio el area; el diagnostico
// clinico sigue reservado y solo se deja la fila para que se sepa que existe.
function ResumenAtencion({ atencion }) {
    const integrado = origenEstaIntegrado(atencion.origen);
    const textoPendiente = integrado ? SIN_DATO : 'Pendiente de integración';
    return (
        <div style={ESTILO_BLOQUE}>
            <Typography style={ESTILO_TITULO_BLOQUE}>RESUMEN DE LA ATENCIÓN</Typography>
            <Typography style={ESTILO_ETIQUETA}>Motivo</Typography>
            <Typography style={{ ...ESTILO_PARRAFO, color: atencion.motivo ? '#212121' : '#9a9a9a' }}>
                {atencion.motivo || textoPendiente}
            </Typography>
            <Typography style={ESTILO_ETIQUETA}>Cierre</Typography>
            <Typography style={{ ...ESTILO_PARRAFO, color: atencion.cierre ? '#212121' : '#9a9a9a' }}>
                {atencion.cierre || (atencion.fecha_atencion === 'Sin atender' ? 'La atención aún no se ha cerrado.' : textoPendiente)}
            </Typography>
            <Typography style={ESTILO_ETIQUETA}>Diagnóstico clínico</Typography>
            <Typography style={atencion.diagnostico ? { ...ESTILO_PARRAFO, marginBottom: 0 } : ESTILO_RESERVADO}>
                {atencion.diagnostico
                    || (atencion.reservado
                        ? 'Bajo reserva profesional — no se muestra en Bienestar'
                        : textoPendiente)}
            </Typography>
        </div>
    );
}

const ESTILO_FILA = { display: 'flex', gap: 10, fontSize: 13, padding: '8px 0', borderBottom: '1px solid #eaeaea' };
const ESTILO_CLAVE = { color: '#5f5f5f', flex: '0 0 150px' };
const ESTILO_VALOR = { color: '#212121', flex: 1, minWidth: 0 };
const ESTILO_AVISO = {
    marginTop: 14, background: '#f7f9fc', borderRadius: 8, padding: '12px 14px',
    display: 'flex', gap: 10, alignItems: 'flex-start',
};

function Fila({ etiqueta, valor, atenuado = false }) {
    return (
        <div style={ESTILO_FILA}>
            <Typography style={ESTILO_CLAVE} component="span">{etiqueta}</Typography>
            <Typography style={{ ...ESTILO_VALOR, color: atenuado ? '#c4c4c4' : ESTILO_VALOR.color }} component="span">
                {valor}
            </Typography>
        </div>
    );
}

// Nivel de trazabilidad: solo datos administrativos de la atencion. El contenido
// clinico de los origenes reservados no se muestra en Bienestar.
function DialogAtencionTrazabilidad({ open, atencion, onClose, chipEstado }) {
    if (!atencion) return null;
    const sinAtender = atencion.fecha_atencion === 'Sin atender';
    const solicitud = atencion.bienestar;
    return (
        <Dialog open={open} onClose={onClose} maxWidth={solicitud ? 'md' : 'sm'} fullWidth scroll="paper" PaperProps={{ style: BIENESTAR_MODAL_PAPER_FLEX }}>
            <AppBarModal titulo="Detalle de la atención" mostrarModal={onClose} titulo_accion="" />
            <DialogContent style={{ flex: '1 1 auto', minHeight: 0, overflowY: 'auto', padding: '16px 20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
                    <Typography style={{ fontSize: 15, fontWeight: 500 }}>{atencion.opcion_seleccionada}</Typography>
                    <Chip
                        size="small"
                        label={atencion.origen_nombre}
                        style={{ height: 22, fontSize: 11, borderRadius: 11, backgroundColor: '#e8e8e8', color: '#424242' }}
                    />
                    <span style={{ marginLeft: 'auto' }}>{chipEstado ? chipEstado(atencion.estado) : null}</span>
                </div>
                {solicitud ? (
                    <DetalleSolicitud bienestar={solicitud} />
                ) : (
                    <>
                        <Fila etiqueta="Tipo de atención" valor={atencion.opcion_seleccionada} />
                        <Fila etiqueta="Origen" valor={atencion.origen_nombre} />
                        <Fila etiqueta="Profesional" valor={atencion.profesional || SIN_DATO} />
                        <Fila etiqueta="Quién remite" valor={atencion.quien_remite} />
                        <Fila etiqueta="Fecha de solicitud" valor={atencion.fecha_solicitud} />
                        <Fila
                            etiqueta="Fecha de atención"
                            valor={sinAtender ? 'Sin registrar' : atencion.fecha_atencion}
                            atenuado={sinAtender}
                        />
                    </>
                )}
                <div style={{ ...ESTILO_FILA, ...(solicitud ? { marginTop: 8 } : null) }}>
                    <Typography style={ESTILO_CLAVE} component="span">Asistencia</Typography>
                    <span style={{ flex: 1, minWidth: 0 }}><ChipAsistencia asistencia={atencion.asistencia} /></span>
                </div>
                <ResumenAtencion atencion={atencion} />
                {atencion.reservado && (
                    <div style={ESTILO_AVISO}>
                        <LockOutlinedIcon style={{ fontSize: 19, color: '#7a8aa0', marginTop: 1 }} />
                        <Typography style={{ fontSize: 12.5, color: '#47566b', lineHeight: 1.5 }}>
                            De esta atención se muestra el resumen general. El diagnóstico clínico está bajo
                            reserva profesional y no se consulta desde Bienestar.
                        </Typography>
                    </div>
                )}
            </DialogContent>
            <DialogAccionesCerrarBienestar onClick={onClose} />
        </Dialog>
    );
}

export default React.memo(DialogAtencionTrazabilidad);
